import { useCallbackOne } from "use-memo-one";

import { useOrganization } from "../components/organizations/OrganizationProvider";
import { SalesDataItem } from "../components/sales-data/SalesDataPage";
import usePromise from "../components/utils/usePromise";
import { timePeriodToQueryParams } from "../util/timePeriodFormatting";
import { useDataStore, SalesDataTimePeriod } from "./index";

export interface SalesDataResponse {
  success: true;
  recipes: SalesDataItem[];
  timePeriod: SalesDataTimePeriod;
}

export default function useSalesData(
  filterParams = "",
  selectedTimePeriod: SalesDataTimePeriod | null = null
) {
  const dataStore = useDataStore();
  const [dashboardOrganization] = useOrganization();

  const load = useCallbackOne(async () => {
    if (selectedTimePeriod === null) {
      return new Promise<never>(() => {});
    }

    const timePeriodParams = timePeriodToQueryParams(selectedTimePeriod);
    const combinedParams = [filterParams, timePeriodParams]
      .filter(Boolean)
      .join("&");

    return await dataStore.fetchSalesData(
      dashboardOrganization.id,
      combinedParams
    );
  }, [dataStore, dashboardOrganization, filterParams, selectedTimePeriod]);

  return usePromise(load);
}
